module.exports = __webpack_public_path__ + "static/media/basic_tablet.5d5fe964.svg";